const state = {
  loadingPrice: false,
  loadingCustomPrice: false,
  price: {},
  loadingPlan: false,
  planName: {},
  loadingGeneration: false,
};

const getters = {
  loadingPrice(state) {
    return state.loadingPrice;
  },
  loadingCustomPrice(state) {
    return state.loadingCustomPrice;
  },
  price(state) {
    return state.price;
  },
  loadingPlan(state) {
    return state.loadingPlan;
  },
  planName(state) {
    return state.planName;
  },
  loadingGeneration(state) {
    return state.loadingGeneration;
  },
};

const actions = {
  updateLoadingPrice({ commit }, payload) {
    commit("UPDATE_LOADING_PRICE", payload);
  },
  updateCustomPrice({ commit }, payload) {
    commit("UPDATE_LOADING_CUSTOM_PRICE", payload);
  },
  updatePrice({ commit }, payload) {
    commit("UPDATE_PRICE", payload);
  },
  updateLoadingPlan({ commit }, payload) {
    commit("UPDATE_LOADING_PLAN", payload);
  },
  updateLoadingGeneration({ commit }, payload) {
    commit("UPDATE_LOADING_GENERATION", payload);
  },
};

const mutations = {
  UPDATE_LOADING_PRICE(state, payload) {
    state.loadingPrice = payload;
  },
  UPDATE_LOADING_CUSTOM_PRICE(state, payload) {
    state.loadingCustomPrice = payload;
  },
  UPDATE_PRICE(state, payload) {
    state.price = payload;
  },
  UPDATE_LOADING_PLAN(state, payload) {
    state.loadingPlan = payload;
  },
  UPDATE_LOADING_GENERATION(state, payload) {
    state.loadingGeneration = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
